import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import type {Translator} from '@yandex-delivery/core/i18n'
import {addQuery} from '@yandex-delivery/utils'

import type {PickupPoints, PickupPointsRequest, PickupStation, PickupStationsList} from '../../model/types'
import {isUserAddressPin} from '../../utils/isUserAddressPin'
import type {FetchFunction} from '../fetch'
import {createCityService} from './city-service'
import {toPickupDropoffRequest, toPickupPoints} from './mappers/toPickupPoints'
import type {FetchPickupPointsParams, PickupPointsServiceParams} from './types'

export function createPickupRouteService({params, fetch, countryCode, i18n}: PickupPointsServiceParams) {
  const {fetchCity} = createCityService(params, fetch, countryCode)

  return {
    async fetchPickupPoints({addressPin, isSource, isBusiness}: FetchPickupPointsParams): Promise<PickupPoints> {
      const source = isUserAddressPin(addressPin) ? addressPin.coordinates : undefined

      return fetchCity(addressPin)
        .then(toPickupDropoffRequest)
        .then(selectPickupPointParams(isSource, isBusiness))
        .then(body => fetchPickUpDropOffPoints(body, fetch, countryCode, i18n))
        .then(toPickupPoints(source, i18n('ndd.pickup_points.schedule_everyday', 'Ежедневно')))
    },
  } as const
}

export function selectPickupPointParams(isSource?: boolean, isBusiness?: boolean) {
  return function _selectPickupPointParams(body: PickupPointsRequest): PickupPointsRequest {
    if (isSource) {
      if (isBusiness) {
        body['available_for_dropoff'] = true
      } else {
        body['available_for_c2c_dropoff'] = true
      }
      
      body['payment_method'] = 'already_paid'
    } else {
      body['is_yandex_branded'] = true
      body['type'] = 'pickup_point'
    }

    return body
  }
}

export function fetchPickUpDropOffPoints(
  body: PickupPointsRequest,
  fetch: FetchFunction,
  countryCode: string,
  i18n: Translator,
): Promise<PickupStation[]> {
  return fetch<PickupPointsRequest, PickupStation[], PickupStationsList>({
    url: addQuery(externalApiURL('/platform/pickup-points/list'), {country: countryCode}),
    method: 'POST',
    body,
  }).then((response: PickupStationsList) => {
    if (response.points) {
      return response.points
    }

    throw new Error(i18n('ndd.offers.info.error', 'К сожалению, доставка по указанному адресу недоступна'))
  })
}
